<template>

    <tr class="position-relative">
        <!--        <td>
                    <input type="checkbox" class="form-check-input" v-model="selectedModel" :value="this.$vnode.key" @change="$emit('change', $event.target.checked)">
                </td>-->
        <slot />
<!--        <td class="text-end">
            <i class="bi bi-chevron-right"></i>
        </td>-->
    </tr>

</template>

<script>

    export default {
        props: [
            'selected',
        ],
        data() {
            return {
                selectedModel: this.selected
            };
        },
        components: {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>